module.exports = __webpack_public_path__ + "img/edit.d6e84549.svg";